module.exports = __webpack_public_path__ + "img/campaign-step-1.0b1a5635.jpg";